import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://tfnimwasnajhfrrazyjt.supabase.co'
const supabaseAnonKey = 'sb_publishable_jcwnVXr6BV5YVcYlDP3EPA_hSZN9DX9'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// 认证相关函数
export const auth = {
  // 注册
  async signUp(email, password) {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
    })
    return { data, error }
  },

  // 登录
  async signIn(email, password) {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    })
    return { data, error }
  },

  // 登出
  async signOut() {
    const { error } = await supabase.auth.signOut()
    return { error }
  },

  // 获取当前用户
  async getCurrentUser() {
    const { data: { user } } = await supabase.auth.getUser()
    return user
  },

  // 监听认证状态变化
  onAuthStateChange(callback) {
    return supabase.auth.onAuthStateChange(callback)
  }
}

// 数据库操作函数
export const db = {
  // 获取用户的所有物品
  async getItems(userId) {
    const { data, error } = await supabase
      .from('items')
      .select('*')
      .eq('user_id', userId)
      .order('created_at', { ascending: false })
    return { data, error }
  },

  // 添加物品
  async addItem(item) {
    const { data, error } = await supabase
      .from('items')
      .insert([item])
      .select()
    return { data, error }
  },

  // 更新物品
  async updateItem(id, updates) {
    const { data, error } = await supabase
      .from('items')
      .update(updates)
      .eq('id', id)
      .select()
    return { data, error }
  },

  // 删除物品
  async deleteItem(id) {
    const { error } = await supabase
      .from('items')
      .delete()
      .eq('id', id)
    return { error }
  },

  // 获取分类
  async getCategories(userId) {
    const { data, error } = await supabase
      .from('categories')
      .select('*')
      .eq('user_id', userId)
      .order('name')
    return { data, error }
  },

  // 添加分类
  async addCategory(category) {
    const { data, error } = await supabase
      .from('categories')
      .insert([category])
      .select()
    return { data, error }
  },

  // 更新分类
  async updateCategory(id, updates) {
    const { data, error } = await supabase
      .from('categories')
      .update(updates)
      .eq('id', id)
      .select()
    return { data, error }
  },

  // 删除分类
  async deleteCategory(id) {
    const { error } = await supabase
      .from('categories')
      .delete()
      .eq('id', id)
    return { error }
  },

  // 获取标签
  async getTags(userId) {
    const { data, error } = await supabase
      .from('tags')
      .select('*')
      .eq('user_id', userId)
      .order('name')
    return { data, error }
  },

  // 添加标签
  async addTag(tag) {
    const { data, error } = await supabase
      .from('tags')
      .insert([tag])
      .select()
    return { data, error }
  }
}
